import React, {useState} from 'react';
import Dropzone, {DropzoneRootProps, DropzoneInputProps} from 'react-dropzone';
import {Box, Stack, Tooltip, Typography} from "@mui/material";
import {styles} from "../../../common/style";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";

function FileUpload(props: { state: any, setState: any }) {
    console.log('FileUpload');

    const handleDrop = (acceptedFiles: File[]) => {
        console.log(acceptedFiles);
        let list = props.state.files.concat(acceptedFiles);
        props.setState({
            ...props.state,
            files: list
        })
    };

    const deleteFile = (index: number) => {
        console.log(props.state.files);
        props.state.files.splice(index, 1)
        props.setState({
            ...props.state,
            files: [...props.state.files]
        })
    }

    return (
        <Stack sx={{width: 1}}>
            <Stack sx={{
                width: 1, background: '#eaf5fb',
                border: 'dashed 1px #a7a7a7', cursor: 'pointer', mt: 1
            }}>
                <Dropzone onDrop={handleDrop}>
                    {({
                          getRootProps,
                          getInputProps
                      }: { getRootProps: () => DropzoneRootProps, getInputProps: () => DropzoneInputProps }) => (
                        <Stack {...getRootProps()}
                               sx={{minHeight: 41, pt:1 , pb: 1, display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
                            <input {...getInputProps()} />
                            <Typography align={"center"} sx={{color: '#4e4e4e'}}>첨부파일은 여기에 파일을 끌어다 놓거나 클릭하세요.</Typography>
                            <Typography align={"center"} sx={{color: '#ff0000ad'}}>
                                * 본문에 들어갈 이미지 파일은 위의 에디터에서 추가해 주세요.
                            </Typography>
                        </Stack>
                    )}
                </Dropzone>
            </Stack>

            <Stack sx={{
                display: props.state.files.length > 0 ? '' : 'none',
                p: 2,
                pb: 1,
                pt: 1,
                my: 0.5,
                border: styles.border,
                background: 'var(--scc-surface)'
            }}>
                {props.state.files.map((file: File, index: number) => (
                    <Box key={file.name} sx={{display: 'flex', mb: 0.5}}>
                        <Typography sx={{}}>
                            {index + 1}) {file.name}
                        </Typography>

                        <Tooltip title={'삭제'}>
                            <DeleteIcon color={'error'}
                                        onClick={() => deleteFile(index)}
                                        sx={{cursor: 'pointer', ml: 1}}/>
                        </Tooltip>
                    </Box>
                ))}
            </Stack>
        </Stack>
    );
}

export default FileUpload;